import type { TagJSONObject } from '@ikegps/core-api';
import { IkeRestObject } from './base';

export class IkeObjectTag extends IkeRestObject<TagJSONObject> {
	className = 'Tag' as const;
	actionName = 'tag';
	object?: TagJSONObject;

	constructor() {
		super();
		this.cacheKeys['uuid'] = true;
	}
}
